const blockClassName = '.cities-list';
const slider = document.querySelector(`${blockClassName}__slider .swiper`);
let init = false;
let swiper;

if (slider) {
  const swOptions = {
    keyboard: { enabled: true },
    a11y: { enabled: true },
    watchOverflow: true,
    slidesPerView: 2.2,
    spaceBetween: 8,
    init: false,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 8,
      },
      992: {
        slidesPerView: 3.2,
        spaceBetween: 12,
      },
      1200: {
        slidesPerView: 5.2,
        spaceBetween: 24,
      },
      1400: {
        slidesPerView: 6.2,
        spaceBetween: 23.11,
      }
    },
    navigation: {
      prevEl: `${blockClassName}.swiper-slider-nav .swiper-button-prev`,
      nextEl: `${blockClassName}.swiper-slider-nav .swiper-button-next`,
    },
    scrollbar: {
      el: `${blockClassName}__slider .swiper-scrollbar`,
      draggable: true,
    },
  };

  async function initSwiper() {
    const desktop = window.matchMedia('(min-width: 1200px)');
    if (desktop.matches) {
      if (!init) {
        // Lazy-load Swiper only on desktop — avoids 131KB download on mobile
        const { Swiper, Navigation, Keyboard, A11y, Scrollbar } = await import('../vendor/swiper');
        init = true;
        swiper = new Swiper(slider, { ...swOptions, modules: [Navigation, Keyboard, A11y, Scrollbar] });
      }
      swiper.init();
    } else {
      if (init) {
        swiper.destroy();
        init = false;
      }
    }
  }

  window.addEventListener('load', initSwiper);
  window.addEventListener('resize', initSwiper);
}
